import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import { temaEvolfin } from './primevue-theme';
import { localeIt } from './primevue-locale';
import { router } from './router';
import { inizializzaCsrf } from './api/client';
import App from './App.vue';
import './assets/main.css';

async function avvia(): Promise<void> {
  // Il cookie CSRF va preso prima della prima mutazione: da lì in poi
  // l'interceptor axios lo rispedisce da sé.
  await inizializzaCsrf().catch(() => {
    // Se l'API non risponde, l'app parte comunque e mostrerà l'errore in UI.
  });

  createApp(App)
    .use(createPinia())
    .use(router)
    .use(VueQueryPlugin, {
      queryClientConfig: {
        defaultOptions: {
          queries: {
            // Dati di un gestionale interno: freschi per poco, niente refetch
            // aggressivo a ogni focus di finestra.
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      },
    })
    .use(PrimeVue, { theme: temaEvolfin, ripple: false, locale: localeIt })
    .use(ToastService)
    .use(ConfirmationService)
    .mount('#app');
}

void avvia();
